import React, { useContext } from 'react';
import { Route, Routes } from 'react-router-dom';
import { v4 as uuidV4 } from 'uuid';
import { PublicRoutes } from './PublicRoutes';
const MainPage = React.lazy(() =>
  import('Routes/Protected/MainPage/MainPage')
);
import TopNav from 'Global/Components/CommonComponents/TopNav/TopNav';
import NotFoundPage from 'Global/Components/404/NotFoundPage';
import Landing from 'Routes/Public/Landing/Landing';

import { NestedRoutes } from './NestedRoutes/NestedRoutes';
import { words } from './NestedRoutes/words';
import { ControlledNestedRouteWords } from './NestedRoutes/ControlledNestedRouteWords';
import { ControlledNestedRoutes } from './NestedRoutes/ControlledNestedRoutes';
import useCheckScreenWidth from 'Global/Hooks/useCheckScreenWidth';
import FallbackWrappedElement from './FallbackWrappedElement/FallbackWrappedElement';
import Login from 'Routes/Public/Login/Login';
import { GlobalContext } from 'Global/Context/GlobalContextProvider';
import AccessControl from 'Global/security/AccessControl';

const NestedRouter = ({ rootPaths }) => {
  const word = words();
  const controlled_words = ControlledNestedRouteWords();
  const screenWidth = useCheckScreenWidth();

  const GlobalConstants = useContext(GlobalContext);
  const isWebAppSettingsEnabled = AccessControl(
    'web-app-setting-accordion'
  );
  const AccessRoles = GlobalConstants?.AccessRoles;

  return (
    <Routes>
      <Route index path="/" element={<Login />} />
      {PublicRoutes(
        AccessRoles,
        isWebAppSettingsEnabled
      )?.map((route) => (
        <Route
          key={uuidV4()}
          path={route.path}
          element={
            <>
              {route.title !== null && (
                <TopNav
                  title={route.title}
                  isGeneral={route.isGeneral ?? true}
                  screenWidth={screenWidth}
                />
              )}
              {route.component}
            </>
          }
        />
      ))}

      <Route
        path="/main"
        element={
          <FallbackWrappedElement>
            <MainPage />
          </FallbackWrappedElement>
        }
      >
        {/* <Route path="CurrentPatients" element={<CurrentPatients />} /> */}

        {ControlledNestedRoutes(controlled_words)?.map(
          (route) => {
            const matchingPath = rootPaths.find(
              (path) =>
                route.path === path ||
                `/main${route.path}` === `/main${path}`
            );

            if (matchingPath) {
              const finalPath = route.path.startsWith('/')
                ? route.path.slice(1)
                : route.path;

              return (
                <Route
                  key={uuidV4()}
                  path={finalPath}
                  element={
                    <>
                      {route.title !== null && (
                        <TopNav
                          title={route.title}
                          isGeneral={
                            route.isGeneral ?? true
                          }
                          screenWidth={screenWidth}
                        />
                      )}
                      {route.component}
                    </>
                  }
                />
              );
            }

            return null;
          }
        )}

        {NestedRoutes(
          word,
          AccessRoles,
          isWebAppSettingsEnabled,
          rootPaths
        )?.map((route) =>
          rootPaths.map(
            (paths) =>
              (route.path === paths.substring(1) ||
                route.noAuth) && (
                <Route
                  key={uuidV4()}
                  path={route.path}
                  element={
                    <>
                      {route.title !== null && (
                        <TopNav
                          title={route.title}
                          isGeneral={
                            route.isGeneral ?? true
                          }
                          screenWidth={screenWidth}
                        />
                      )}
                      {route.component}
                    </>
                  }
                />
              )
          )
        )}
      </Route>
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default NestedRouter;
